import { QueryObserverOptions, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '@api/messages';
import { InspectedObjectDetailsDTO } from '../dto/InspectedObjectDetailsDTO';
import getInspectedObjectDetailsById from '../api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<InspectedObjectDetailsDTO>, 'enabled'>;

export default function useGetInspectedObjectDetails(
  id: number,
  ignoreErrorMessage: boolean,
  options?: UseQueryOptionsKeys
) {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery(
    ['getInspectedObjectDetails', id],
    () => getInspectedObjectDetailsById(id),
    {
      onError: error => {
        if (!ignoreErrorMessage) {
          errorMessage({
            title: t('error.object.details.fetch'),
            message: null,
            error,
          });
        }
      },
      ...options,
    }
  );

  return { objectDetailsDTO: data, isFetchingObjectDetailsDTO: isFetching };
}
